'use strict';
import './style.css';
import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

class ItemSlider {
    static init() {
        document.querySelectorAll('.js-two-item-slider').forEach(slider => {
            if (slider.swiper) return;

            const slides = Array.from(slider.children);
            if (!slides.length) return;

            const wrapper = document.createElement('div');
            wrapper.className = 'swiper-wrapper';
            slides.forEach(slide => {
                slide.classList.add('swiper-slide');
                wrapper.append(slide);
            });

            const prev = document.createElement('button');
            prev.type = 'button';
            prev.className = 'swiper-button-prev';
            const next = document.createElement('button');
            next.type = 'button';
            next.className = 'swiper-button-next';
            const pagination = document.createElement('div');
            pagination.className = 'swiper-pagination';

            slider.append(wrapper, prev, next, pagination);
            slider.classList.add('swiper');

            new Swiper(slider, {
                modules: [Autoplay, Navigation, Pagination],
                slidesPerView: 1,
                spaceBetween: 24,
                navigation: {prevEl: prev, nextEl: next},
                pagination: {el: pagination, clickable: true},
                autoplay: {delay: 5000, disableOnInteraction: false},
                breakpoints: {
                    1024: {
                        slidesPerView: 2,
                        autoplay: false
                    }
                }
            });
        });
    }
}

export {ItemSlider};